import React from "react";
import axios from 'axios';
import { Container, Row, Col } from "shards-react";
import PageTitle from "../../../components/common/PageTitle";
import Button from "@material-ui/core/Button";
import InputMask from 'react-input-mask';
	
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';

import  api from '../../common/api';

import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { withStyles } from '@material-ui/styles';

import MediaFile from '../../../components/common/MediaFile'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Link from '@material-ui/core/Link';

import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";
import Backdrop from '@material-ui/core/Backdrop';

import NumberFormat from 'react-number-format';

const styles = theme => ({
  SwitchLabel: {
    '& .MuiFormControlLabel-label': {
      fontSize: '0.75rem',
    },
  },
  formControl: {
  	margin: 10,
    minWidth: 150,
    fontSize: '0.75rem',
  },
  formControlMask: {
    minWidth: 120,
    maxWidth: 300,
    margin: '0px',
    marginTop: '4px'
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  },
  typography_contact: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    margin:0,
    fontSize: '1.2rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
});

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <InputMask
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={['(', /[0-9]/, /\d/, /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
}


class InsuranceForm extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			insurance:{
						id:'', insurance_type_id:'', insurance_broker_id:'', insurance_producer_id:'',
						name:'', description:'', coverage:'', franchise_ammount:'', franchise_percentage:'',
						policy_number:'', start_date:'', end_date:'',
						subcontacts:[
							{'contact_type':'Grua',firstname:'',lastname:'',email:'',phone:''},
							{'contact_type':'Ejecutivo de cuenta',firstname:'',lastname:'',email:'',phone:''},
							{'contact_type':'Denuncias / Reclamos',firstname:'',lastname:'',email:'',phone:''},
//							{'contact_type':'Reclamos',firstname:'',lastname:'',email:'',phone:''}							
						]
					},
			brokers:[],
			producers:[],
			insurance_types:[],
			files:[{}],
			media:[{}],
			dialogOpen: false,
			loading: true,
			errors: false,
          	backdrop: false,
			subcontacts_to_delete:[]
		}

		this.handleUploadFile = this.handleUploadFile.bind(this)
		this.handleOpenDialog = this.handleOpenDialog.bind(this)
	
	}
	componentDidMount() {
		var params = this.getParams();
		var id = params.id
		var view = params.view
		this.setParams();
		if (id !== undefined){
			this.getInsurance(id)			
			if (view === '1'){
				this.setState({disabled: true, action: 'view'})
			} else {
				this.setState({action: 'edit'})
			}
		} else {
			this.setState({action: 'new' })
		}

	}

	handleUploadFile(file, meta_data){
		var files_state = this.state.files
		var file = {file: file, meta_data: meta_data}
		files_state.push(file)
		this.setState({files: files_state})
	}	

	getParams(){
		return this.props.match.params
	}

	getInsurance(id){
	    const token =localStorage.getItem('userToken')
	    return axios
	         .get(api.insurances().get(id),{ headers: {"Authorization" : `Bearer ${token}`} })
	          .then(res => {
	              res.data = Object.values(res.data);
	              var subcontacts = []
	              var media = []
	              res.data[0].subcontacts.map((val, idx)=>{
	              	var subcontact = {}
	              	subcontact.firstname = val.subcontact.firstname
	              	subcontact.lastname = val.subcontact.lastname
	              	subcontact.contact_type = val.contact_type
	              	subcontact.email = val.subcontact.contact.email
	              	subcontact.phone = val.subcontact.contact.phone
	              	subcontact.id = val.subcontact.id
	              	subcontacts.push(subcontact);
	              })
	              res.data[0].subcontacts = subcontacts
	              if (res.data[0].subcontacts.length === 0){
	              	res.data[0].subcontacts = [
							{'contact_type':'Grua',firstname:'',lastname:'',email:'',phone:''},
							{'contact_type':'Ejecutivo de cuenta',firstname:'',lastname:'',email:'',phone:''},
							{'contact_type':'Denuncias',firstname:'',lastname:'',email:'',phone:''},
							{'contact_type':'Reclamos',firstname:'',lastname:'',email:'',phone:''}							
						]
	              }
	              media = res.data[0].media
	              res.data[0]['description'] = res.data[0]['description'] || ''
	              this.setState({insurance: res.data[0], media})
	              return res.data
	          })
	          .catch(err =>{console.log(err)
	          })
	}

	async setParams(){
		const token = localStorage.getItem('userToken')
		var results =  await axios
	    .all([
	    	  axios.get(api.insurances().producers(),{ headers: {"Authorization" : `Bearer ${token}`} }),
	    	  axios.get(api.insurances().brokers(),{ headers: {"Authorization" : `Bearer ${token}`} }),
	    	  axios.get(api.insurances().insurance_types(),{ headers: {"Authorization" : `Bearer ${token}`} }),
	               
	    ])
	    .then(
	    axios.spread((...responses) => {
	      const producers = responses[0].data;
	      const brokers = responses[1].data;
	      const insurance_types = responses[2].data;
          this.setState({
	              producers,
	              brokers,
	              insurance_types,
	              loading: false
	          })
	        }))

	}

 	handleChangeSubcontacts = (event) => {
	    event.preventDefault();	
		var res = event.target.name.split(".");
	    var value = event.target.value
	    var insurance = this.state.insurance
	    insurance.subcontacts[res[1]][res[2]] = value 
	    this.setState({insurance: insurance})
 	}

 	handleChange = (event) => {
	    event.preventDefault();	
	    var key = event.target.name
	    var value = event.target.value
	    var insurance = this.state.insurance
        if (key ==='franchise_ammount'){
          value = value.replace('$','').replace(/\,/g,'')
      	}
		insurance[key] = value

	    if (key === 'insurance_type_id' || key === 'insurance_broker_id' || key === 'insurance_producer_id' && insurance.name === ''){
	    	insurance.name = ''
	    	if (insurance.insurance_broker_id !== ''){
	    		insurance.name += this.state.brokers.filter(broker => parseInt(broker.id) === parseInt(insurance.insurance_broker_id))[0].name
	    	}
	    	if (insurance.insurance_producer_id !== ''){
	    		insurance.name += ' - ' + (this.state.producers.filter(producer => parseInt(producer.id) === parseInt(insurance.insurance_producer_id))[0].name)
	    	}
	    	if (insurance.insurance_type_id !== ''){
	    		insurance.name += ' - ' + (this.state.insurance_types.filter(insurance_type => parseInt(insurance_type.id) === parseInt(insurance.insurance_type_id))[0].name)
	    	}
	    }

	    this.setState({insurance: insurance})
 	}


   handleSubmit = (event) => {
    	this.setState({backdrop: true})
	    event.preventDefault();
	    event.stopPropagation();
	    var formData = new FormData();
	    formData.set("insurance[name]", this.state.insurance.name);
	    formData.set("insurance[description]", this.state.insurance.description);
	    formData.set("insurance[insurance_type_id]", this.state.insurance.insurance_type_id);
	    formData.set("insurance[insurance_broker_id]", this.state.insurance.insurance_broker_id);
	    formData.set("insurance[insurance_producer_id]", this.state.insurance.insurance_producer_id);
	    formData.set("insurance[coverage]", this.state.insurance.coverage);
	    formData.set("insurance[franchise_ammount]", this.state.insurance.franchise_ammount);
	    formData.set("insurance[franchise_percentage]", this.state.insurance.franchise_percentage);
	    formData.set("insurance[policy_number]", this.state.insurance.policy_number);
	    formData.set("insurance[start_date]", this.state.insurance.start_date || '');
	    formData.set("insurance[end_date]", this.state.insurance.end_date || '');
	    formData.set("insurance[update_closure]", this.state.insurance.update_closure || '');

	    var subcontact_idx = 0
	    this.state.insurance.subcontacts.map((val,idx)=>{
			if (val.firstname && val.lastname && val.email){
				formData.set("insurance[subcontacts]["+subcontact_idx+"][contact_type]", val.contact_type);
				formData.set("insurance[subcontacts]["+subcontact_idx+"][firstname]", val.firstname);
				formData.set("insurance[subcontacts]["+subcontact_idx+"][lastname]", val.lastname);
				formData.set("insurance[subcontacts]["+subcontact_idx+"][email]", val.email);
				formData.set("insurance[subcontacts]["+subcontact_idx+"][phone]", val.phone);
				if (val.id !== '' && val.id !== undefined){
					formData.set("insurance[subcontacts]["+subcontact_idx+"][id]", val.id);
				}
				subcontact_idx++;
			}
	    })	

	    this.state.subcontacts_to_delete.map((val,idx)=>{
		    if (val.id !== '' && val.id !== undefined){
			    formData.set("insurance[subcontacts]["+subcontact_idx+"][id]", val.id);
			    formData.set("insurance[subcontacts]["+subcontact_idx+"][contact_type]", val.contact_type);
			    formData.set("insurance[subcontacts]["+subcontact_idx+"][firstname]", val.firstname);
			    formData.set("insurance[subcontacts]["+subcontact_idx+"][lastname]", val.lastname);
			    formData.set("insurance[subcontacts]["+subcontact_idx+"][email]", val.email);
			    formData.set("insurance[subcontacts]["+subcontact_idx+"][phone]", val.phone);
			    formData.set("insurance[subcontacts]["+subcontact_idx+"][deleted_at]", Date());
			    subcontact_idx++;
		    }
	    })	

	    var i = 0;

		if (this.state.files){
			this.state.files.map((val, idx) => {
				if (val.file !== '' && val.file !== undefined){
					formData.append("media["+i+"][file]", val.file[0])
					formData.set("media["+i+"][meta_data_name]", 'tipo_documento')
					formData.set("media["+i+"][meta_data_value]", val.meta_data)
					i++;
				}	
			})
		}

		let self = this


		const token =localStorage.getItem('userToken')

		if (this.state.action ==='new'){
		  axios.post(api.insurances().post(),
		     formData,
		     {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
		     )
		    .then((response)=> {
		        self.setState({errors: false, save_insurance: true})
		        self.setState({message: 'Seguro creado con éxito!'})
		        self.setState({dialogOpen: true})
                self.handleCloseBackdrop()
		    })
		    .catch(function (error) {
		        self.setState({errors: true})
		        self.setState({message: 'Hubo un problema al guardar el seguro. Por favor volver a intentar'})
		        self.setState({dialogOpen: true})
                self.handleCloseBackdrop()
		  })
		} else {
			formData.set('insurance[id]', this.state.insurance.id)
			formData.append('_method', 'patch');
			axios.post(api.insurances().patch(this.state.insurance.id),
			formData,
			{headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
			)
			.then((response)=> {
			  self.setState({errors: false, save_insurance: true})
			  self.setState({message: 'Seguro modificado con éxito!'})
			  self.setState({dialogOpen: true})
			  self.handleCloseBackdrop()
			})
			.catch(function (error) {
			  self.setState({errors: true, save_insurance: false})
			  self.setState({message: 'Hubo un problema al guardar el seguro. Por favor volver a intentar'})
			  self.setState({dialogOpen: true})
			  self.handleCloseBackdrop()
			})

		}
	}

	handleOpenDialog(message, media_id){
		this.setState({dialogOpen: true, message: message, confirm_document_delete: true, media_id: media_id})		
	}

	handleDeleteDocument(){
		var media = this.state.media
		var media_id = this.state.media_id
	    let self = this
	    const token = localStorage.getItem('userToken')
	    axios.delete(api.media().delete(media_id),
	     {params: {'media[id]':media_id }},{ headers: {"Authorization" : `Bearer ${token}`} }
	      )

	      .then((response)=> {
	          self.setState({errors: false})
	          self.setState({delete_document: true})
			  media.map((val, idx)=>{
			    if (val.id === media_id){
			      media = media.filter((s, sidx) => idx !== sidx)
			    }
			  })
	          self.setState({media_id: '',media: media})
	          self.setState({dialogOpen: true})
	          self.setState({confirm_document_delete: false})
	          self.setState({message: 'Documento eliminado con éxito!'})
	      })
	      .catch(function (error) {
	          self.setState({errors: true})
	          self.setState({delete_document: false})
	          self.setState({confirm_document_delete: false})
	          self.setState({message: 'Ocurrio un problema al intentar eliminar el documento. Contacte a su administrador.'})
	          self.setState({dialogOpen: true})
	          self.setState({media_id: ''})
	    })
	}

	addNewItem = (contact_type) => {
		var insurance = this.state.insurance
		insurance.subcontacts.push({'contact_type':contact_type,firstname:'',lastname:'',email:'',phone:''})		
		this.setState({insurance: insurance})
	}

	removeItem = (e, idx) => {
		var insurance = this.state.insurance
		var subcontacts_to_delete = this.state.subcontacts_to_delete
		subcontacts_to_delete.push(insurance.subcontacts[idx])
		insurance.subcontacts = insurance.subcontacts.filter((s, sidx) => idx !== sidx);
		this.setState({insurance: insurance})
	}

	handleCloseBackdrop = () => {
		var backdrop = !this.state.backdrop
		this.setState({backdrop: backdrop})
	}


	render(){
	    const handleRedirect = id => () =>{
	      window.location.href=`/insurances`
	    }

	    const handleDialogClose = () => {
	      this.setState({dialogOpen: false, confirm_document_delete: false, delete_document: false})
	    }        
		const { classes } = this.props;
	    const disabled = this.state.disabled
	    const { brokers, producers, insurance, insurance_types} = this.state
		var has_instructivo = false;
		var has_formulario = false;
		return(
	       <Container fluid className="main-content-container px-4 pb-4">
	          <Row noGutters className="page-header pt-4">
	            <PageTitle sm="4" title={"Seguro"} className="text-sm-left" />
	          </Row>
	          <Row>
	            <Col md="12">
	              <React.Fragment>
	              {(this.state.dialogOpen)?
	                <Dialog
	                  open={this.state.dialogOpen}
	                  fullWidth
	                  aria-labelledby="responsive-dialog-title"
	                >
	                  <DialogTitle id="responsive-dialog-title">{"Seguro"}</DialogTitle>
	                  <DialogContent>
	                    <DialogContentText>
	                        {this.state.message}
	                    </DialogContentText>
	                  </DialogContent>
	                  <DialogActions disableSpacing="false">  

                      {(this.state.delete_document)?
                        <Button onClick={(e)=> {handleDialogClose()}} variant="contained" color="primary" >
                            Aceptar
                        </Button>
                        :
                        ''
                       }


	                  {(this.state.confirm_document_delete)
                  		? 
                  		<React.Fragment>
	                        <Button onClick={(e)=> {handleDialogClose()}} variant="contained" color="primary" className="mr-2">
	                            Cancelar
	                        </Button>
	                        <Button onClick={(e)=>{this.handleDeleteDocument()}} variant="contained" color="primary" className="mr-2" >
	                            Aceptar
	                        </Button>
                        </React.Fragment>

	                  	:
	                  	''
	                  }
                      {(this.state.save_insurance)?
                        <Button onClick={handleRedirect()} variant="contained" color="primary" >
                            Aceptar
                        </Button>
                        :
                        ''
                       }
	                  {(this.state.errors) ?
	                      <Button onClick={(e)=>{handleDialogClose()}} variant="contained" color="primary" >
	                          Aceptar
	                      </Button>
	                      :
	                      ''
	                    }
	                  </DialogActions>
	                </Dialog>
	              :''}
	              {(this.state.loading)?
	                 <LinearProgress /> 
	              :
	              <div>
	                <form onSubmit={this.handleSubmit}>
	                	<div className="row ml-1">

							<FormControl className="mt-3 mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name='insurance_producer_id' >
								<Typography className={classes.typography}>Aseguradora</Typography>
								<Select native name='insurance_producer_id'
								    inputProps={{
								      name:"insurance_producer_id",
								      className:"insurance_producer_id"
								    }}
								    style={{minWidth: 150, fontSize: '0.75rem'}}
								    disabled={disabled}
								    onChange={this.handleChange}
								    required
								    value={insurance.insurance_producer_id}
								    input={<Input id="grouped-native-select" name='insurance_producer_id'/>}>
								    <option value="" label="Seleccione" />
								    	{producers.map((producer) => <option id={producer.id} value={producer.id}>{producer.name}
								  </option>)}
								</Select>
							</FormControl>


							<FormControl className="mt-3 mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name='insurance_type_id' >
								<Typography className={classes.typography}>Tipo de Cobertura</Typography>
								<Select native name='insurance_type_id'
								    inputProps={{
								      name:"insurance_type_id",
								      className:"insurance_type_id"
								    }}
								    style={{minWidth: 150, fontSize: '0.75rem'}}
								    disabled={disabled}
								    onChange={this.handleChange}
								    required
								    value={insurance.insurance_type_id}
								    input={<Input id="grouped-native-select" name='insurance_type_id'/>}>
								    <option value="" label="Seleccione" />
								    	{insurance_types.map((insurance_type) => <option id={insurance_type.id} value={insurance_type.id}>{insurance_type.name}
								  </option>)}
								</Select>
							</FormControl>

							<FormControl className="mt-3 mr-2" style={{minWidth: 150, fontSize: '0.75rem'}} name='insurance_broker_id' >
								<Typography className={classes.typography}>Broker</Typography>
								<Select native name='insurance_broker_id'
								    inputProps={{
								      name:"insurance_broker_id",
								      className:"insurance_broker_id"
								    }}
								    style={{minWidth: 150, fontSize: '0.75rem'}}
								    disabled={disabled}
								    onChange={this.handleChange}
								    required
								    value={insurance.insurance_broker_id}
								    input={<Input id="grouped-native-select" name='insurance_broker_id'/>}>
								    <option value="" label="Seleccione" />
								    	{brokers.map((broker) => <option id={broker.id} value={broker.id}>{broker.name}
								  </option>)}
								</Select>
							</FormControl>

							<TextField
								id="name"
								name="name"
								label="Nombre"
								disabled={disabled}
								type="text"
								required
								placeholder="Ingrese el nombre del seguro"
								onChange={this.handleChange}
								value={insurance.name}
								margin="normal"
								className="mr-2 "
								InputLabelProps={{
								  shrink: true
								}}
								inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
							/>

							<TextField
								id="coverage"
								name="coverage"
								label="Detalle Cobertura"
								disabled={disabled}
								type="text"
								required
								placeholder="Ingrese la cobertura"
								onChange={this.handleChange}
								value={insurance.coverage}
								margin="normal"
								className="mr-2 "
								InputLabelProps={{
								  shrink: true
								}}
								inputProps={{style:{minWidth: 400, fontSize: '0.75rem'}}} 
							/>

							<TextField
								id="policy_number"
								name="policy_number"
								label="Número de póliza"
								disabled={disabled}
								type="text"
								required
								placeholder="Ingrese el número de póliza"
								onChange={this.handleChange}
								value={insurance.policy_number}
								margin="normal"
								className="mr-2 "
								InputLabelProps={{
								  shrink: true
								}}
								inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
							/>

							<TextField
								id="start_date"
								name="start_date"
								label="Fecha desde"
								disabled={disabled}
								type="date"
								required
								placeholder="Ingrese la fecha de inicio"
								onChange={this.handleChange}
								value={insurance.start_date}
								margin="normal"
								className="mr-2 "
								InputLabelProps={{
								  shrink: true
								}}
								inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
							/>

							<TextField
								id="end_date"
								name="end_date"
								label="Fecha hasta"
								disabled={disabled}
								type="date"
								required
								placeholder="Ingrese la fecha hasta"
								onChange={this.handleChange}
								value={insurance.end_date}
								margin="normal"
								className="mr-2 "
								InputLabelProps={{
								  shrink: true
								}}
								inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
							/>

{/*							<TextField
								id="franchise_ammount"
								name="franchise_ammount"
								label="Monto franquicia"
								disabled={disabled}
								type="number"
								placeholder="Ingrese el monto de franquicia"
								onChange={this.handleChange}
								value={insurance.franchise_ammount}
								margin="normal"
								className="mr-2 "
								InputLabelProps={{
								  shrink: true
								}}
								inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
							/>
*/}
							<NumberFormat 
							    id="franchise_ammount"
							    name="franchise_ammount"
							    label="Monto franquicia"
							    placeholder="Ingrese el monto de franquicia"
							    disabled={disabled}
							    className="mt-3 mr-2"
							    InputProps={{style: {fontSize: '0.75rem', width: 250}}}
							    value={insurance.franchise_ammount}
							    onChange={this.handleChange}
							    thousandSeparator=','
							    decimalSeparator='.'
							    prefix={'$'}
							    customInput={TextField}  
							    InputLabelProps={{
							      shrink: true,
							    }}
							    isAllowed={(values) => {
							      let { floatValue } = values;
							      floatValue = (floatValue !== undefined) ? floatValue : 0
							      return floatValue >= 0;
							    }}            

							/>
							<TextField
								id="franchise_percentage"
								name="franchise_percentage"
								label="Porcentaje franquicia"
								disabled={disabled}
								type="number"
								placeholder="Ingrese el porcentaje de franquicia"
								onChange={this.handleChange}
								value={insurance.franchise_percentage}
								margin="normal"
								className="mr-2 "
								InputLabelProps={{
								  shrink: true
								}}
								inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
							/>

							<TextField
								id="description"
								name="description"
								label="Observaciones"
								disabled={disabled}
								type="text"
								fullWidth
								placeholder="Ingrese observaciones"
								onChange={this.handleChange}
								value={insurance.description}
								margin="normal"
								className="mr-2 "
								InputLabelProps={{
								  shrink: true
								}}
								inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
							/>
							<TextField
								id="update_closure"
								name="update_closure"
								label="Cláusula Actualización"
								disabled={disabled}
								type="text"
								fullWidth
								placeholder="Ingrese clausula actualización"
								onChange={this.handleChange}
								value={insurance.update_closure}
								margin="normal"
								className="mr-2 "
								InputLabelProps={{
								  shrink: true
								}}
								inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
							/>
						</div>
						{
							(insurance.subcontacts.map((val,idx)=>{
								var last_contact_type = ''
								if (idx > 0){
									last_contact_type = insurance.subcontacts[idx-1].contact_type
								}
								return (
										<React.Fragment>
											{(last_contact_type === val.contact_type)
												?
													''
												:
													<React.Fragment>
														<div className="row ml-1">
															<Typography className={classes.typography_contact} style={{alignSelf:'center'}}>{insurance.subcontacts[idx].contact_type}</Typography>
											                <IconButton size="small" className={classes.iconButton} onClick={(e)=> {this.addNewItem(val.contact_type)}}>
											                      <AddIcon className={classes.deleteIcon}/>
											                </IconButton>
														</div>
													</React.Fragment>

											}
											<div className="row ml-1">
												<TextField
													id={"subcontacts."+idx+".firstname"}
													name={"subcontacts."+idx+".firstname"}
													label="Nombre"
													disabled={disabled}
													type="text"
													required
													placeholder="Ingrese el nombre"
													onChange={this.handleChangeSubcontacts}
													value={insurance.subcontacts[idx].firstname}
													margin="normal"
													className="mr-2 mt-1"
													InputLabelProps={{
													  shrink: true
													}}
													inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
												/>
												<TextField
													id={"subcontacts."+idx+".lastname"}
													name={"subcontacts."+idx+".lastname"}
													label="Apellido"
													disabled={disabled}
													type="text"
													required
													placeholder="Ingrese el apellido"
													onChange={this.handleChangeSubcontacts}
													value={insurance.subcontacts[idx].lastname}
													margin="normal"
													className="mr-2 mt-1"
													InputLabelProps={{
													  shrink: true
													}}
													inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
												/>
												<TextField
													id={"subcontacts."+idx+".email"}
													name={"subcontacts."+idx+".email"}
													label="Email"
													disabled={disabled}
													type="email"
													required
													placeholder="Ingrese el email"
													onChange={this.handleChangeSubcontacts}
													value={insurance.subcontacts[idx].email}
													margin="normal"
													className="mr-2 mt-1"
													InputLabelProps={{
													  shrink: true
													}}
													inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
												/>
												<FormControl className={classes.formControlMask} inputProps={{shrink: true}}><Typography className={classes.typography}>Telefono fijo</Typography>
													<Input
													id={"subcontacts."+idx+".phone"}
													name={"subcontacts."+idx+".phone"}
													disabled={disabled}
													placeholder="Ingrese el teléfono fijo"
													margin="normal"
													className="mr-2 mt-0"
													inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
													value={insurance.subcontacts[idx].phone}
													onChange={this.handleChangeSubcontacts}
													inputComponent={TextMaskCustom}
													/>
												</FormControl>
								                <IconButton size="small" className={classes.iconButton} onClick={(e)=> {this.removeItem(e, idx)}} >
								                  <RemoveIcon className={classes.deleteIcon} />
								                </IconButton>
											</div>
										</React.Fragment>

								)
								
							}))
						}

						<Typography variant="h6" gutterBottom >Documentación</Typography>
						{(	
							this.state.media.map((val, idx)=>{
								if (val.custom_properties !== undefined){
									if (val.custom_properties.tipo_documento === 'instructivo') {
										has_instructivo = true;
									} 
									if (val.custom_properties.tipo_documento === 'formulario') {
										has_formulario = true;
									} 
									var message = 'Esta seguro de eliminar el '+val.custom_properties.tipo_documento + '?'
									return (
										<React.Fragment>
											<div></div>
							              	<Link href={api.media_download+'/'+val.id}><ArrowDownwardIcon />Descargar {val.custom_properties.tipo_documento}</Link>
							              	<Button onClick={(e) => { this.handleOpenDialog(message, val.id)} }><ArrowDownwardIcon />Eliminar {val.custom_properties.tipo_documento}</Button>
										</React.Fragment>
									)
								}
							})
						)}
						<div className="row col-12">
						{(!has_formulario)
						?
							<MediaFile onChange={this.handleUploadFile} title="Agregar formulario" width={"15rem"} height={"2rem"}  meta_data="formulario" />
						:
							''
						}
						{(!	has_instructivo)
						?
							<MediaFile onChange={this.handleUploadFile} title="Agregar instructivo" width={"15rem"} height={"2rem"} meta_data="instructivo" />
						:
							''
						}
						</div>
		                {(this.state.action !== 'view')?
		                  <React.Fragment>
		                    <Button type="submit" variant="contained" className="mt-3 ml-1 mr-1"  color="primary">
		                      Guardar
		                    </Button>
		                    <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/insurances/"}>
		                      Cancelar
		                    </Button>
		                  </React.Fragment>
		                :
		                  <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/insurances/"}>
		                    Volver
		                  </Button>
		                }
	              </form>
	            </div>
	            }
	            </React.Fragment>
	          </Col>
	        </Row>
            <React.Fragment>
                  <Backdrop open={this.state.backdrop} onClick={this.handleCloseBackdrop} style={{zIndex: 10000, color: '#3f51b5'}}>
                      <Typography className="ml-2" variant="h5" color="primary">Guardando...</Typography>
                  </Backdrop>
            </React.Fragment>
	      </Container>

		)
	}  

}

export default withStyles(styles)(InsuranceForm);